export default __webpack_public_path__ + "static/media/protectors-unite-desktop.81511716.mp4";